export default "__VITE_ASSET__Bg7Ph4lf__"